export const PAGINATION = {
  PAGE_SIZE: 20,
  PAGE: 1,
};

export const LOCALE_ENGLISH = 'en-US';
export const LOCALE_ENGLISH_SHORTHAND = 'en';
export const LOCALE_CHINESE = 'zh-CN';
export const LOCALE_CHINESE_SHORTHAND = 'zh';
export const LOCALE_DEFAULT = LOCALE_ENGLISH_SHORTHAND;

export const LOCALES = [
  { value: 'en', label: 'EN' },
  { value: 'zh-CN', label: '中文' },
];

export const SORT_BY = 'date';
export const GENERATION_LEVEL = 1;
export const FRACTION_DIGITS = 6;

export const ROUTER_ACTION_REFRESH = 'ACTION_REFRESH';
export const ROUTER_ACTION_RESTART = 'ACTION_RESTART';
